<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" class="mb10" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import SwbUseturnVoucherItemList from './UseturnVoucherItemList.vue';
    Vue.regist(SwbUseturnVoucherItemList);
    //
    import shareAcckApi from '../../api/shareAcc'

    //
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    //

    export default {
        name: 'swb-share-acc-stock-list-for-select',
        desc: '共享配件选择',
        props: {
            checkedIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            comId: {
                type: Number,
                default: null
            },
            warehouseId: {
                type: Number,
                default: null
            },
            isSelect: {
                type: Boolean,
                default: null
            }
        },
        data: function () {
            return {
                confKey: "swb-share-acc-stock-list-for-select",
                queryOnLoad: true,
                tableHeight: 510, //表格高度
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: null,//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: false, //操作列是否固定

                pageNumber: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                }
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
        },
        mounted() {
            this.initResultTable();
            //
            if(Utils.isTrue(this.isDisabled)) {
                // 禁用数据处理
                let initChecked = this.checkedIds;
                let resultTable = this.$refs.result_table;
                resultTable.setInitChecked(initChecked, true);
            } else {
                //回显数据处理
                let initChecked = this.checkedIds;
                let resultTable = this.$refs.result_table;
                resultTable.setInitChecked(initChecked, false);
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'accName': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if(row.specificFlag) {
                            domHtml = domHtml + '<span class="swb-tags swb-tags-success">' + "个" + '</span>';
                        }
                        domHtml = domHtml + '<span>' + row.accName + '</span>';
                        return domHtml;
                    },
                    'price': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //缓存查询条件
                this.getShareAccStockList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getShareAccStockList();
            },
            //
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getShareAccStockList();
            },
            getShareAccStockList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(this.comId)) {
                    filterItems.comId = this.comId;
                }
                if(!Utils.isNoB(this.warehouseId)) {
                    filterItems.warehouseId = this.warehouseId;
                }
                if(!Utils.isNoB(this.isSelect)) {
                    filterItems.isSelect = this.isSelect;
                }
                filterItems.custMerchantType = getEnumInfoWith("merchantType", "name", "Retailer").value;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                shareAcckApi.getShareAccStockList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        //
                        self.renderTable(result.data.rows, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = 'info';
                //
                let selectList = this.getTableSelection();
                if(selectList != null && selectList.length > 0) {
                    result.type = "info";
                    result.data = selectList;
                } else {
                    result.type = 'wran';
                    result.message = "请选择配件";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shareAcc/StockListForSelect.vue